import { render, staticRenderFns } from "./ad-slider.vue?vue&type=template&id=c87909fa"
import script from "./ad-slider.vue?vue&type=script&lang=js"
export * from "./ad-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports